<template>
  <!-- PRODUCT FAMILY COMP -->
  <div class="mt-8 overflow-hidden rounded-md border border-solid border-[--color-neutral-a4]">
    <div
      class="font-medium leading-6 [&_>div:first-child]:border-0 [&_>div:last-child]:border-0 [&_>div]:border-b [&_>div]:border-[--color-neutral-a4] [&_>div]:px-5 [&_>div]:py-3"
    >
      <div class="bg-[--color-neutral-a6] px-5 py-[14px]">
        <h3 class="my-0 text-lg font-semibold text-[--color-neutral-a05] lg:text-xl">
          {{ $t("shared.product.product_family_label") }}
        </h3>
      </div>
      <div>
        <a
          v-dompurify-html="familyPageName"
          class="font-medium text-[--color-link] hover:text-[--color-neutral-a1]"
          :href="familyPageLink"
        ></a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface IProps {
  familyPageName?: string;
  familyPageId?: string;
  productCode?: string;
}

const props = defineProps<IProps>();

const familyPageLink = computed(() => {
  if (!props.familyPageId) {
    return "";
  }
  if (props.productCode) {
    return `${props.familyPageId}?pn=${props.productCode}`;
  }
  return props.familyPageId;
});
</script>
